import moment from "moment";
const formatPhoneNumber = (phone) => {
  let number = phone.replace(/\D/g, ''); //does not allow alphabets 
  return number.slice(0, 10)
  // const areaCode = number.slice(0, 1);
  // const prefix = number.slice(1, 6);
  // const lastFour = number.slice(6, 11);
  // const firstDash = prefix ? "-" : "";
  // const secondDash = lastFour ? "-" : "";
  // return `${areaCode}${firstDash}${prefix}${secondDash}${lastFour}`;
};
const over18 = (date) => {
  const eighteenYears = 60 * 24 * 365 * 18;
  const start = moment(new Date(date));
  const today = moment();
  const diff = today.diff(start, "minutes");
  return diff >= eighteenYears;
};

//========= name validation --> name input field should not enable user to type numeric values ======//
const nameValidator = (value) => {
  let name = value.replace(/[0-9,%<>\\$'"]/i, '')
  return name
}

// ======== phone number should be 11 digits long ======//
const phoneValidation = (phone) => {
  return phone.length === 10
}


const formatDate = (date, format = "YYYY-MM-DD") => {
  return moment(date).format(format);
}

export { formatPhoneNumber, over18, nameValidator, phoneValidation, formatDate };
